module.exports = __webpack_public_path__ + "bdd06f4f901c17adfcf2ec3de92d7797.png";